import React from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormTextarea,
  CRow,
} from '@coreui/react-pro'
import { useEditGiftCategory } from './hooks'
import { setGiftCategory, submitEditGiftCategory } from './model'
export const GiftCategoryEditDetail = () => {
  const { giftCategory, loading } = useEditGiftCategory()
  const handleChange = (event: {
    currentTarget: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.currentTarget.type === 'checkbox'
        ? event.currentTarget.checked
        : event.currentTarget.value

    setGiftCategory({
      ...giftCategory,
      [event.currentTarget.name]: value,
    })
  }

  if (loading) {
    return <div>Downloading</div>
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Edit gift category {giftCategory.id}</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="name"
                  name="name"
                  value={giftCategory.name}
                  onChange={handleChange}
                  label="Name"
                />
              </CCol>
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="title"
                  name="title"
                  value={giftCategory.title}
                  onChange={handleChange}
                  label="Title"
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={8}>
                <CFormTextarea
                  id="description"
                  name="description"
                  value={giftCategory.description}
                  onChange={handleChange}
                  label="Description"
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormCheck
                  id="isShow"
                  name="isShow"
                  checked={giftCategory.isShow}
                  onChange={handleChange}
                  label="Availability to order"
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="sorting"
                  name="sorting"
                  value={giftCategory.sorting}
                  onChange={handleChange}
                  label="Sorting"
                />
              </CCol>
            </CRow>
            <CButton
              className="mb-3"
              disabled={loading}
              onClick={() => submitEditGiftCategory(giftCategory)}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Save
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </div>
  )
}
